import React from 'react';

import { Chip as MuiChip } from '@material-ui/core';
import { ChipProps as MuiChipProps } from '@material-ui/core/Chip';
// import { makeStyles, Theme } from '@material-ui/core/styles';

export interface ChipProps extends MuiChipProps {
  endIcon?: JSX.Element;
  label?: string;
  size?: 'small' | 'medium';
  startIcon?: JSX.Element;
}

// const useStyles = makeStyles((theme: Theme) => ({
//   chip: {},
// }));

export const Chip = (props: ChipProps): JSX.Element => {
  // const classes = useStyles();
  const {
    endIcon = '',
    label = '',
    id = 0,
    size = 'medium',
    startIcon = '',
    ...rest
  } = props;

  const chipContent = (
    <>
      {startIcon}
      {label}
      {endIcon}
    </>
  );

  return (
    <MuiChip
      // className={classes.chip}
      clickable
      data-id={id}
      label={chipContent}
      size={size}
      variant="outlined"
      {...rest}
    />
  );
};
